import { NgModule } from '@angular/core';
import { LoginWorktocloudComponent } from './login-worktocloud.component';



@NgModule({
  declarations: [LoginWorktocloudComponent],
  imports: [
  ],
  exports: [
    LoginWorktocloudComponent
  ]
})
export class LoginWorktocloudModule { }
